/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DashboardAssetInfo } from './DashboardAssetInfo';
import {
    DashboardAssetInfoFromJSON,
    DashboardAssetInfoFromJSONTyped,
    DashboardAssetInfoToJSON,
} from './DashboardAssetInfo';

/**
 * 
 * @export
 * @interface DashboardAssetList
 */
export interface DashboardAssetList {
    /**
     * 
     * @type {Array<DashboardAssetInfo>}
     * @memberof DashboardAssetList
     */
    result: Array<DashboardAssetInfo>;
}

/**
 * Check if a given object implements the DashboardAssetList interface.
 */
export function instanceOfDashboardAssetList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function DashboardAssetListFromJSON(json: any): DashboardAssetList {
    return DashboardAssetListFromJSONTyped(json, false);
}

export function DashboardAssetListFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardAssetList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': ((json['result'] as Array<any>).map(DashboardAssetInfoFromJSON)),
    };
}

export function DashboardAssetListToJSON(value?: DashboardAssetList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': ((value.result as Array<any>).map(DashboardAssetInfoToJSON)),
    };
}

